/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import { useFieldHelper } from 'framework/ui/field';
import useArtifactService from '../artifactService';
import { CROP_SIZES } from '../constants';
import { SanitizedHtml } from 'framework/utils';
import { Box } from '@mui/material';
import { parseHtmlInert } from 'domain/shared/artifact/parseHtmlInert';

const aimAttrName = 'data-aim';

const getInitialValue = (value: string) => {
  const div = parseHtmlInert(value);
  const artifacts = div.querySelectorAll('artifact');

  artifacts.forEach(artifact => {
    const tmp = document.createElement('div');
    tmp.innerHTML = '<i class="fa fa-spinner fa-spin" />';
    const spinner = tmp.firstChild;
    if (spinner) {
      artifact.parentNode?.replaceChild(spinner, artifact);
    }
  });

  return <SanitizedHtml html={div.innerHTML} wrapperTag="p" />;
};

const HtmlWithArtifactFieldDecorator = ({ children }: { children: React.ReactElement }) => {
  const { getValue } = useFieldHelper(children.props);
  const { getArtifactsDataByIds } = useArtifactService();
  const inputValue = getValue();

  const [displayedValue, setDisplayedValue] = useState(getInitialValue(inputValue));

  const getPreparedImage = (artifactData?: { id?: string; title?: string; thumbnails?: Dictionary<string> }) => {
    const image = document.createElement('img');
    image.alt = artifactData?.title || 'not-found';
    image.src = artifactData?.thumbnails ? artifactData.thumbnails[CROP_SIZES.SIZE_100] : '';
    image.className = 'inserted-artifact';
    image.setAttribute(aimAttrName, artifactData?.id || '');

    return image;
  };

  const initializeDisplayedValue = async () => {
    const div = parseHtmlInert(inputValue);
    const artifacts = div.querySelectorAll('artifact');

    const artifactsData = await getArtifactsDataByIds(Array.from(artifacts).map(artifact => artifact.id));

    artifacts.forEach(artifact => {
      const image = getPreparedImage(artifactsData.find(artifactData => artifactData.id === artifact.id));
      artifact.parentNode?.replaceChild(image, artifact);
    });

    setDisplayedValue(<SanitizedHtml html={div.innerHTML} wrapperTag="p" />);
  };

  useEffect(() => {
    initializeDisplayedValue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue]);

  const handleClick = ({ target }: React.MouseEvent<HTMLDivElement>) => {
    const aim = (target as Element).getAttribute(aimAttrName);

    if (aim) {
      const artifactPreview = document.querySelector(`img[id="${aim}"]`);
      (artifactPreview as HTMLElement | null)?.click();
    }
  };

  return (
    <Box
      onClick={handleClick}
      data-testid="artifact-field-decorator"
      sx={{ '& .inserted-artifact': { cursor: 'pointer' } }}
    >
      {React.cloneElement(children, {
        value: displayedValue,
      })}
    </Box>
  );
};

export default HtmlWithArtifactFieldDecorator;
